export default {
  title: 'Usuń dane wartości zadań',
  confirmDelete: {
    header: 'Usunąć wartości "{item}"?',
    message: 'Wszystkie wartości od {from} do {to} zostaną usunięte. Tej operacji nie można cofnąć.',
  },
};
